var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wysiwyg-viewer"},[(_vm.iframe)?_c('iframe',{ref:"frame",staticStyle:{"width":"100%","height":"500px","border":"none"}}):_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }